<template>
    <div class="content-bottom">&copy版权所有:{{academyName}} 成人高考考前辅导平台</div>
</template>

<script>
    export default {
        name: "MyBottom",
        data() {
            return {
              academyName:''
            }
        },
        created() {
          const student = JSON.parse(localStorage.getItem('student') );
          this.academyName = student.academy_name;
        }
    }
</script>

<style lang="scss" scoped>
    .content-bottom {
        width: 100%;
        height: 60px;
        font-family: PingFang SC;
        font-size: 14px;
        color: #666;
        line-height: 60px;
        text-align: center;
        background-color: #e8e8e8;
    }
</style>
